import React, { useState, useEffect, useCallback, useRef } from "react";
import VideoList from "./components/VideoList";
import VideoPlayer from "./components/VideoPlayer";
import LoginModal from "./components/LoginModal";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Button,
  Navbar,
  Container,
  Offcanvas,
  Form,
  Modal,
} from "react-bootstrap";

function App() {
  const [email, setEmail] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [videos, setVideos] = useState([]); // Store video list
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [headerHtml, setHeaderHtml] = useState('H<sub>2</sub>S Academy');
  const [storageNamespace, setStorageNamespace] = useState(null);
  const [welcomeTitleHtml, setWelcomeTitleHtml] = useState('Welcome to H<sub>2</sub>S Academy');
  const [videoProgress, setVideoProgress] = useState({});
  const [showSidebar, setShowSidebar] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 992); // lg breakpoint

  const defaultLogoSrc = "/assets/logo_small.png";
  const [logoSrc, setLogoSrc] = useState(defaultLogoSrc);

  const defaultCssHref = "/assets/App_hach.css";
  const defaultFaviconHref = "/favicon.ico";

  const [emailInput, setEmailInput] = useState("");
  const [showError, setShowError] = useState(""); // Controls error message visibility and content

  const [agreeChecked, setAgreeChecked] = useState(false);

  const lastSentProgressBucketByVideoIdRef = useRef({});

  const getEmailStorageKey = useCallback((namespace) => {
    const ns = namespace === "hach" ? "hach" : namespace === "sl" ? "sl" : "default";
    return `userEmail_${ns}`;
  }, []);

  const getVideoProgressStorageKey = useCallback((namespace) => {
    const ns = namespace === "hach" ? "hach" : namespace === "sl" ? "sl" : "default";
    return `videoProgress_${ns}`;
  }, []);

  const handleVideoListLoaded = useCallback((loadedVideos) => {
    const stripAutoplayFromUrl = (url) => {
      if (typeof url !== "string" || url.length === 0) return url;
      try {
        const parsed = new URL(url);
        parsed.searchParams.delete("autoplay");
        return parsed.toString();
      } catch {
        // Fallback for non-standard URLs
        return url.replace(/([?&])autoplay=\d+(&)?/i, (match, sep, amp) => (sep === "?" && amp ? "?" : sep === "?" ? "" : amp ? "&" : ""));
      }
    };

    const normalizedVideos = (Array.isArray(loadedVideos) ? loadedVideos : []).map((video) => ({
      ...video,
      url: stripAutoplayFromUrl(video?.url),
      hasBeenViewed: false,
    }));

    setVideos(normalizedVideos);

    // Set the default video only if no video is currently selected
    if (!selectedVideo && normalizedVideos.length > 0) {
      setSelectedVideo(normalizedVideos[0]);
    }
  }, [selectedVideo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submit button clicked");
    if (emailInput.includes("@")) {
      try {
        console.log("Submit button clicked2");
        const response = await fetch(
          `${window.location.origin}/api/login.php`,
          {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams({ email: emailInput }),
          }
        );
        console.log("Submit button clicked3");

        if (response.ok) {
          console.log("Submit button clicked4");

          const emailKey = getEmailStorageKey(storageNamespace);
          localStorage.setItem(emailKey, emailInput);
          setEmail(emailInput);
          setShowModal(false);
          setShowSidebar(false);
          setShowError(""); // Clear error on successful login
          //setSelectedVideo(videos[0]); // Default to the first video
        } else {
          setShowError("Login failed. Please try again.");
        }
      } catch (error) {
        setShowError("An error occurred. Please try again later.");
      }
    } else {
      setShowError("Please enter a valid email address.");
    }
  };

  const viewedVideos = videos.filter((video) => video.hasBeenViewed).length;

  const calculateViewedPercentage = () => {
    const totalVideos = videos.length;
    return totalVideos > 0 ? Math.round((viewedVideos / totalVideos) * 100) : 0;
  };

  useEffect(() => {
    if (!storageNamespace) return;

    const checkEmail = () => {
      const emailKey = getEmailStorageKey(storageNamespace);
      const savedEmail = localStorage.getItem(emailKey);
      if (savedEmail) {
        //console.log("email saved");
        //setEmail(savedEmail);
      } else {
        console.log("show modal");
        //setShowModal(true);
        setShowSidebar(false);
      }
    };

    // Delay execution to ensure DOM readiness
    const timeoutId = setTimeout(checkEmail, 0);

    return () => clearTimeout(timeoutId); // Cleanup on unmount
  }, [getEmailStorageKey, storageNamespace]);

  useEffect(() => {
    let isMounted = true;

    const applyThemeStylesheet = (href) => {
      const resolvedHref = typeof href === "string" && href.length > 0 ? href : defaultCssHref;

      const linkId = "app-theme-css";
      let linkEl = document.getElementById(linkId);

      if (!linkEl) {
        linkEl = document.createElement("link");
        linkEl.id = linkId;
        linkEl.rel = "stylesheet";
        document.head.appendChild(linkEl);
      }

      linkEl.href = resolvedHref;
    };

    const applyFavicon = (href) => {
      const resolvedHref = typeof href === "string" && href.length > 0 ? href : defaultFaviconHref;
      const lowerHref = resolvedHref.toLowerCase();
      const type = lowerHref.endsWith(".ico") ? "image/x-icon" : "image/png";

      const iconLinks = Array.from(
        document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]')
      );

      if (iconLinks.length === 0) {
        const linkEl = document.createElement("link");
        linkEl.rel = "icon";
        linkEl.href = resolvedHref;
        linkEl.type = type;
        document.head.appendChild(linkEl);
        return;
      }

      iconLinks.forEach((linkEl) => {
        linkEl.href = resolvedHref;
        linkEl.type = type;
      });
    };

    applyThemeStylesheet(defaultCssHref);
    applyFavicon(defaultFaviconHref);

    const loadSiteProvider = async () => {
      try {
        const queryString = String(window.location.search || "");
        const providerUrl = `${window.location.origin}/api/site_provider.php${queryString}`;

        const response = await fetch(
          providerUrl,
          {
            method: "GET",
            cache: "no-store",
          }
        );

        if (!response.ok) {
          throw new Error(`site_provider.php returned ${response.status}`);
        }

        const data = await response.json();
        const resolvedLogoSrc = data?.logoSrc || null;
        const resolvedCssHref = data?.cssHref || null;
        const resolvedFaviconHref = data?.faviconHref || null;

        const resolvedNamespace = typeof data?.storageNamespace === "string" ? data.storageNamespace : null;
        const resolvedWelcomeTitleHtml = typeof data?.welcomeTitleHtml === "string" ? data.welcomeTitleHtml : null;
        const resolvedTitleText = typeof data?.titleText === "string" ? data.titleText : null;

        if (!isMounted) return;

        if (typeof resolvedLogoSrc === "string" && resolvedLogoSrc.length > 0) {
          setLogoSrc(resolvedLogoSrc);
        } else {
          setLogoSrc(defaultLogoSrc);
        }

        if (typeof resolvedCssHref === "string" && resolvedCssHref.length > 0) {
          applyThemeStylesheet(resolvedCssHref);
        } else {
          applyThemeStylesheet(defaultCssHref);
        }

        if (
          typeof resolvedFaviconHref === "string" &&
          resolvedFaviconHref.length > 0
        ) {
          applyFavicon(resolvedFaviconHref);
        } else {
          applyFavicon(defaultFaviconHref);
        }

        if (resolvedNamespace === "hach" || resolvedNamespace === "sl") {
          setStorageNamespace(resolvedNamespace);
        } else {
          setStorageNamespace("sl");
        }

        if (typeof resolvedWelcomeTitleHtml === "string" && resolvedWelcomeTitleHtml.length > 0) {
          setWelcomeTitleHtml(resolvedWelcomeTitleHtml);
        }

        if (typeof resolvedTitleText === "string" && resolvedTitleText.length > 0) {
          document.title = resolvedTitleText;
        }
      } catch (error) {
        if (!isMounted) return;
        setLogoSrc(defaultLogoSrc);
        applyThemeStylesheet(defaultCssHref);
        applyFavicon(defaultFaviconHref);

        // If the provider API fails, default to the secondary namespace.
        setStorageNamespace("sl");
      }
    };

    loadSiteProvider();

    return () => {
      isMounted = false;
    };
  }, [defaultLogoSrc]);

  useEffect(() => {
    let isMounted = true;

    const loadVideoList = async () => {
      try {
        const params = new URLSearchParams(window.location.search || "");
        params.set("resource", "videos");
        const url = `${window.location.origin}/api/site_provider.php?${params.toString()}`;

        const response = await fetch(url, {
          method: "GET",
          cache: "no-store",
        });

        if (!response.ok) {
          throw new Error(`site_provider.php returned ${response.status}`);
        }

        const data = await response.json();
        const serverVideos = Array.isArray(data) ? data : data?.videos;

        if (!isMounted) return;

        if (typeof data?.headerHtml === "string" && data.headerHtml.length > 0) {
          setHeaderHtml(data.headerHtml);
        }

        handleVideoListLoaded(Array.isArray(serverVideos) ? serverVideos : []);
      } catch (error) {
        // Keep existing defaults if the list cannot be loaded.
      }
    };

    loadVideoList();

    return () => {
      isMounted = false;
    };
  }, [handleVideoListLoaded]);

  useEffect(() => {
    // Check video progress in localStorage
    if (storageNamespace) {
      try {
        const progressKey = getVideoProgressStorageKey(storageNamespace);
        const raw = localStorage.getItem(progressKey);
        const savedProgress = raw ? JSON.parse(raw) : null;
        if (savedProgress) setVideoProgress(savedProgress);
      } catch (e) {
        // Ignore invalid JSON
      }
    }

    const handleResize = () => {
      const nowLargeScreen = window.innerWidth >= 992;
      setIsLargeScreen(nowLargeScreen);

      // Never auto-open the menu due to resize; only close it when switching to large.
      if (nowLargeScreen) setShowSidebar(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [getVideoProgressStorageKey, storageNamespace]);

  const handleLogin = (userEmail) => {
    setEmail(userEmail);
    const emailKey = getEmailStorageKey(storageNamespace);
    localStorage.setItem(emailKey, userEmail);
  };

  const handleVideoWatch = (videoId, position) => {
    if (typeof email !== "string" || email.length === 0) return;

    const percentage = Math.max(0, Math.min(100, Math.round(position)));
    const bucket = Math.floor(percentage / 5) * 5;
    const lastBucket = lastSentProgressBucketByVideoIdRef.current[videoId];

    // Only send when progress advances to a new 5% bucket.
    if (typeof lastBucket === "number" && bucket <= lastBucket) return;
    lastSentProgressBucketByVideoIdRef.current[videoId] = bucket;

    const queryString = String(window.location.search || "");
    const url = `${window.location.origin}/api/mark-watched.php${queryString}`;

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, videoId, position: percentage }),
      keepalive: true,
    }).catch(() => {
      // Best-effort telemetry; ignore network errors.
    });
  };

  const handleNextVideo = () => {
    const currentIndex = videos.findIndex(
      (video) => video.id === selectedVideo?.id
    );
    if (currentIndex < videos.length - 1) {
      setSelectedVideo(videos[currentIndex + 1]);
    }
  };

  const handlePreviousVideo = () => {
    const currentIndex = videos.findIndex(
      (video) => video.id === selectedVideo?.id
    );
    if (currentIndex > 0) {
      setSelectedVideo(videos[currentIndex - 1]);
    }
  };

  return (
    <div className="app">

      <Modal show={showModal} centered enforceFocus={true} backdrop="static" keyboard={false}>
        <Form onSubmit={handleSubmit}>
          <Modal.Header>
            <Modal.Title className="fw-bold">
              <span dangerouslySetInnerHTML={{ __html: welcomeTitleHtml }} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Enter your business email to get access:</Form.Label>
              <Form.Control
                type="email"
                value={emailInput}
                onChange={(e) => {
                  setEmailInput(e.target.value);

                  // Automatically check the box when the user types in the input field
                  if (e.target.value) setAgreeChecked(true);
                }}
                placeholder="Business email"
                autoFocus
              />
              {showError && (
                <Form.Text className="text-danger">
                  {showError}
                </Form.Text>
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Form.Group className="d-flex align-items-center">
              <Form.Check
                type="checkbox"
                id="agree-terms"
                className="me-2"
                checked={agreeChecked}
                onChange={(e) => setAgreeChecked(e.target.checked)}
              />
              <Form.Label htmlFor="agree-terms" className="m-0 small">
                By entering your email, you agree to the use of cookies, system-generated emails, and data collection for statistics.
              </Form.Label>
            </Form.Group>
            <Button className="w-100 mt-3" variant="primary" type="submit" disabled={!agreeChecked}>
              Enter
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>


      <Navbar
        style={{ backgroundColor: "#FFFFFF" }}
        variant="light"
        expand="lg"
        className="navbar-custom"
      >
        <Container fluid>
          {!isLargeScreen && (
            <Navbar.Toggle
              aria-controls="offcanvas-sidebar"
              className="border-0"
              onClick={() => setShowSidebar(!showSidebar)}
            />
          )}
          <Navbar.Brand href="#" className="d-flex align-items-center mx-lg-0">
            <img src={logoSrc} height={70} alt="Logo" />
          </Navbar.Brand>

          {email && (
            <div className="progress-container d-flex flex-column align-items-center justify-content-center w-50 mx-auto">
              <div className="d-flex justify-content-center align-items-center w-100 mb-1">
                <span className="progress1 fw-bold">
                  {calculateViewedPercentage()}%
                </span>
                <span className="progress2 ms-2">
                  Completed ({viewedVideos}/{videos.length})
                </span>
              </div>
              <div className="progress w-75" style={{ height: "14px" }}>
                <div
                  className="progress-bar bg-primary"
                  role="progressbar"
                  style={{ width: `${calculateViewedPercentage()}%` }}
                  aria-valuenow={calculateViewedPercentage()}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          )}
        </Container>
      </Navbar>

      <div className="main-content d-flex">
        {isLargeScreen ? (
          <div className="sidebar-lg">
            <VideoList
              onVideoSelect={(video) => setSelectedVideo(video)}
              videoProgress={{}}
              currentVideoId={selectedVideo?.id}
              videos={videos}
              headerHtml={headerHtml}
            />
          </div>
        ) : (
          <Offcanvas
            show={showSidebar}
            onHide={() => setShowSidebar(false)}
            placement="start"
            id="offcanvas-sidebar"
            className="sidebar"
            enforceFocus={false} // Disable focus trapping
  autoFocus={false}    // Prevent auto-focusing
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <VideoList
                onVideoSelect={(video) => {
                  setSelectedVideo(video); // Select the video
                  setShowSidebar(false); // Hide the side panel
                }}
                videoProgress={{}}
                currentVideoId={selectedVideo?.id}
                videos={videos}
                headerHtml={headerHtml}
              />
            </Offcanvas.Body>
          </Offcanvas>
        )}
        <div className="player flex-grow-1">
          <div className="player-content">
            <h1 className="mb-4 fw-bold">{selectedVideo?.title}</h1>
            {selectedVideo && (
              <VideoPlayer
                video={selectedVideo}
                progress={videoProgress[selectedVideo.id] || 0}
                onWatch={(percentage) =>
                  handleVideoWatch(selectedVideo.id, percentage)
                }
                autoplay={typeof email == "string"}
              />
            )}

            <div className="d-flex justify-content-between mt-4">
              <div>
                {videos.findIndex((video) => video.id === selectedVideo?.id) >
                  0 && (
                  <Button variant="primary" onClick={handlePreviousVideo}>
                    Previous video
                  </Button>
                )}
              </div>
              <div>
                {videos.findIndex((video) => video.id === selectedVideo?.id) <
                  videos.length - 1 && (
                  <Button variant="primary" onClick={handleNextVideo}>
                    Next video
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
